import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	previewPanelSplitterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	previewPanelSplitterLabel: {
		id: 'page-container-v2.common.preview-panel.preview-panel-splitter-label',
		defaultMessage: 'Resize preview panel',
		description: 'Button label for resizing the preview panel',
	},
});
